export const GET_JEWELLERY_COIN_PRICE = 'GET_JEWELLERY_COIN_PRICE';
export const POST_JEWELLERY_COIN_PRICE = 'POST_JEWELLERY_COIN_PRICE';
export const SET_JEWELLERY_COIN_PRICE = 'SET_JEWELLERY_COIN_PRICE';
export const GET_JCP_LIVE_QUOTE_TABLE = 'GET_LIVE_QUOTE_TABLE';
export const SET_JCP_LIVE_QUOTE_TABLE = 'SET_LIVE_QUOTE_TABLE';
export const CHANGE_JCP_STATUS = 'CHANGE_JCP_STATUS';
export const GET_LATEST_PUBLISHED_JCP = 'GET_LATEST_PUBLISHED_JCP';
export const SET_LATEST_PUBLISHED_JCP = 'SET_LATEST_PUBLISHED_JCP';
export const SEND_PRICE_CHANGE_NOTIFICATION_EMAIL =
  'SEND_PRICE_CHANGE_NOTIFICATION_EMAIL';
export const PUSH_TO_PRONTO = 'PUSH_TO_PRONTO';
